export class RecyclingSchemeValueConverter {
  static x = {
    GRONT_PUNKT: 'Grønt punkt',
    INFINITUM: 'Infinitum',
    NO_RECYCLING: 'Ingen retur',
    INFINITUM_IF_CUSTOMER_IS_KEYKEG_MEMBER: 'Infinitum hvis kunde er med i KeyKeg-pantesystem.',
  };

  toView(value) {
    return RecyclingSchemeValueConverter.toView(value);
  }

  static toView(value) {
    return this.x[value];
  }
}
